<template>
  <v-navigation-drawer
    app
    permanent
    expand-on-hover
    rail
    width="200"
    :style="{ backgroundColor: $vuetify.theme.themes.light.colors.primary }"
    class="d-flex flex-column"
  >
    <div class="d-flex flex-column justify-space-between fill-height">
      <!-- Main Navigation List -->
      <v-list density="compact" nav>
        <v-list-item-group v-model="selectedItem" active-class="custom-active">
          <v-list-item prepend-icon="mdi-view-dashboard" title="Dashboard" value="dashboard" to="/dashboard" router class="nav-icon-color"></v-list-item>
          <v-list-item prepend-icon="mdi-account-multiple" title="Models" value="models" to="/models" router class="nav-icon-color"></v-list-item>
          <v-list-item
            prepend-icon="mdi-finance"
            title="Sales"
            value="sales"
            to="/sales"
            router
            class="nav-icon-color"
            @click="selectItem('sales')"
          ></v-list-item>
          <v-list-item prepend-icon="mdi-file-document-edit-outline" title="Reports" value="reports" to="/reports" router class="nav-icon-color"></v-list-item>
          <v-list-item prepend-icon="mdi-calculator" title="Adjustments" value="adjustments" to="/adjustments" router class="nav-icon-color"></v-list-item>
          <v-list-item prepend-icon="mdi-calendar-clock" title="Calendar" value="calendar" to="/calendar" router class="nav-icon-color"></v-list-item>
          <v-list-item prepend-icon="mdi-credit-card-multiple-outline" title="Payments" value="payments" to="/payments" router class="nav-icon-color"></v-list-item>
        </v-list-item-group>
      </v-list>

      <!-- Account Button (Pinned to Bottom) -->
      <v-list density="compact" nav>
        <v-list-item
          prepend-icon="mdi-account"
          :title="userEmail"
          value="account"
          class="nav-icon-color bottom-button"
          @click="showAccountDialog = true"
        ></v-list-item>
      </v-list>
    </div>

    <!-- Account Dialog -->
    <v-dialog v-model="showAccountDialog" max-width="300">
      <v-card>
        <v-card-title class="headline">Account</v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item>
              <v-list-item-title>Email: {{ userEmail }}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Role: {{ userRole }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="goToConfiguration">
              <v-list-item-title>Configuration</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout">
              <v-list-item-title>Log Out</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="showAccountDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<style scoped>
.nav-icon-color {
  color: #ffffff;
}

.custom-active {
  color: #292E1E !important;
  background-color: rgba(255, 255, 255, 0.2);
}

.bottom-button {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
</style>

<script>
import { toast } from 'vue3-toastify';

export default {
  data() {
    return {
      selectedItem: null,
      showAccountDialog: false,
    };
  },
  computed: {
    userEmail() {
      const user = JSON.parse(localStorage.getItem('user')) || {};
      return user.email || 'Guest';
    },
    userRole() {
      const user = JSON.parse(localStorage.getItem('user')) || {};
      return user.role || 'Unknown';
    },
    isAuthenticated() {
      return !!localStorage.getItem('authToken');
    },
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler(newPath) {
        const routeMap = {
          '/dashboard': 'dashboard',
          '/models': 'models',
          '/sales': 'sales',
          '/reports': 'reports',
          '/adjustments': 'adjustments',
          '/calendar': 'calendar',
          '/payments': 'payments',
        };
        const newSelectedItem = routeMap[newPath] || null;
        if (this.selectedItem !== newSelectedItem) {
          this.selectedItem = newSelectedItem;
        }
      },
    },
  },
  methods: {
    goToConfiguration() {
      this.$router.push('/configuration');
      this.showAccountDialog = false;
    },
    logout() {
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      localStorage.removeItem('rememberedEmail');
      this.$router.push('/login');
      this.showAccountDialog = false;
      toast.success('Logged out successfully', { autoClose: 3000 });
    },
    selectItem(item) {
      this.selectedItem = item;
      this.$router.push('/sales').then(() => {
        console.log('Navigation to /sales succeeded');
      }).catch(err => {
        console.error('Navigation to /sales failed:', err);
      });
    },
  },
  mounted() {
    console.log("🚦 Sidebar mounted, current route:", this.$route.path);
    console.log("🚦 Auth state:", {
      authToken: localStorage.getItem('authToken'),
      user: localStorage.getItem('user'),
      isAuthenticated: this.isAuthenticated,
    });
  },
};
</script>